"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var React = _interopRequireWildcard(require("react"));
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _DataTableStyles = require("web/shared/components/DataTable.styles.js");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* A generic, product-agnostic data table.
*
* Every visual value (type, color, spacing, borders, cell padding) comes from
* the shared token contract (web/shared/tokens.stylex.js), so this component
* has NO product import and themes itself from whichever product's
* `createTheme` wraps the page it renders in.
*
* Columns declare how to render each row's cell; the table owns layout,
* header styling, the empty state, optional row interactivity, and horizontal
* overflow (a wide table scrolls inside its own container, never the page).
*/ // Cell + header text alignment. "right" suits numeric/status columns.
function headerAlignStyle(align) {
  if (align === "right") {
    return _DataTableStyles.styles.headerCellRight;
  }
  if (align === "center") {
    return _DataTableStyles.styles.headerCellCenter;
  }
  return null;
}
function cellAlignStyle(align) {
  if (align === "right") {
    return _DataTableStyles.styles.headerCellRight;
  }
  if (align === "center") {
    return _DataTableStyles.styles.headerCellCenter;
  }
  return null;
}
function DataTable(props) {
  const columns = props.columns,
    rows = props.rows,
    rowKey = props.rowKey,
    emptyMessage = props.emptyMessage,
    onRowClick = props.onRowClick;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_DataTableStyles.styles.scroll)), {}, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("table", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_DataTableStyles.styles.table)), {}, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("thead", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("tr", {
          children: columns.map(column => /*#__PURE__*/(0, _jsxRuntime.jsx)("th", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_DataTableStyles.styles.headerCell, headerAlignStyle(column.align))), {}, {
            children: column.header
          }), column.key))
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("tbody", {
        children: rows.length === 0 ? /*#__PURE__*/(0, _jsxRuntime.jsx)("tr", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("td", (0, _objectSpread2.default)((0, _objectSpread2.default)({
            colSpan: columns.length
          }, stylex.props(_DataTableStyles.styles.empty)), {}, {
            children: emptyMessage != null ? emptyMessage : "Nothing to show yet."
          }))
        }) : rows.map(row => /*#__PURE__*/(0, _jsxRuntime.jsx)("tr", (0, _objectSpread2.default)((0, _objectSpread2.default)({
          onClick: onRowClick != null ? () => onRowClick(row) : undefined
        }, stylex.props(onRowClick != null ? _DataTableStyles.styles.rowClickable : null)), {}, {
          children: columns.map(column => /*#__PURE__*/(0, _jsxRuntime.jsx)("td", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_DataTableStyles.styles.cell, cellAlignStyle(column.align))), {}, {
            children: column.render(row)
          }), column.key))
        }), rowKey(row)))
      })]
    }))
  }));
}
var _default = exports.default = DataTable;